"use strict";

exports.__esModule = true;
exports.TouchScroll = exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = void 0;
var _touchScroll = require("./touchScroll");
exports.PLUGIN_KEY = _touchScroll.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _touchScroll.PLUGIN_PRIORITY;
exports.TouchScroll = _touchScroll.TouchScroll;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/touchScroll/index.js
// module id = 1549
// module chunks = 0